import React, { useState } from "react";
import useMediaQuery from "hooks/useMediaQuery";
import styles from "./index.module.css";
import ScrollToTopButton from "components/common/ScrollToTopButton";
import Skeleton from "components/common/Skeleton";

const BASE = process.env.PUBLIC_URL + "/svg";
const services = `${BASE}/services.svg`;
const serviceMobile = `${BASE}/serviceMobile.svg`;

export default function Services() {
    const isMobile = useMediaQuery("(max-width: 1023px)");
    const [imgLoaded, setImgLoaded] = useState(false);

    // 현재 보여줄 이미지 선택
    const currentImage = isMobile ? serviceMobile : services;

    return (
        <div>
            {!imgLoaded && (
                <Skeleton height={1000} />
            )}

            <img
                src={currentImage}
                className={styles.imgWidths}
                alt="service"
                onLoad={() => setImgLoaded(true)}   // 이미지 로딩 완료 후 표시
                style={{ display: imgLoaded ? "block" : "none" }} // 로드 전 숨김
            />

            <ScrollToTopButton />
        </div>
    );
}
